<template>
<div v-show="visible" class="connectedElement" :style="'z-index:'+zDepth+';'">
  <Connector :pt1="connector1.pt1" :pt2="connector1.pt2"></Connector>
  <VueDragResizeAndRotate id="Expert preview"  :w="150" :sticks="[]" :dragHandle="dragHandle" @dragging="dragging1" class="menuDragger" :style="'top:'+node.pos.y+'px;left:'+node.pos.x+'px;height:160px;background: transparent;'">
         <InfoDisk  @mouseup="mouseup" @mousedown="mousedown" :label="node.label || node.name" :selected="node.selected" :unread="unreadChildern(node.children)" :count="foundChildren(node.children)"/>
           <div v-if="parentNode">parent</div>
  </VueDragResizeAndRotate>
  
  </div>
</template>

<script>
import Connector from "@/components/Connector.vue"
import VueDragResizeAndRotate from 'vue-drag-resize-and-rotate'
import InfoDisk from "@/components/InfoDisk.vue"
export default {
  components: {
    Connector,
    InfoDisk,
    VueDragResizeAndRotate
  },
  props: {
    node:{ default:null},
    index:{ default:null},
    dragging:{ default:null},
    parentNode:{ default:null},
    dragHandle:{type:String, default:null},
    pos:{type: Object,default: function () { return {x:100,y:0} }},
    anchor:{type: Object,default: function () { return {x:0,y:0} }},
    
  },
  data() {
    return {
      dragStart:{x:0,y:0},
      childAnchor:{x:130,y:65},
      self:null,
      mode:null,
      zDepth:1,
      visible:true,
      dsx:0,
      dsy:0,
      dx:0,
      dy:0,
    };
  },
  mounted(){
    this.self=this.node
    
  },
  computed: {
    knownDocs(){
      return this.$store.getters.getKnownDocs
    },
    viewedDocs(){
      return this.$store.getters.getViewedDocs
    },
    anchorParent(){
      if(this.parentNode){
        
         return  {x:this.parentNode.dx+this.anchor.x,y:this.parentNode.dy+this.anchor.y}
      }else{
       return  this.anchor
      }
    },
   connector1(){
      return {pt1:this.anchorParent,pt2:{x:this.node.pos.x+12+this.dx,y:this.node.pos.y+76+this.dy}}
    },
     
  },
  methods: {

    unreadChildern(children){
      let count=0
      
      if(this.node.label=="Evidence" ){
       
        return 0

      }else if(this.node.label=="Locations" && this.viewedDocs){
         
         for(var d in this.knownDocs){
          if(this.knownDocs[d].indexOf("Loc-")>-1){
            count ++
          }
        }
        for(var d in this.viewedDocs){
          if(this.viewedDocs[d].indexOf("Loc-")>-1){
            count --
          }
        }
      }else{  
      for(var child in children){
        if(children[child].found && !children[child].read && !this.viewedDocs.includes(children[child].id)){
          //Read 
          count ++
        }
      }
      }
      return count
    },
     foundChildren(children){
       
       if(this.$store.getters.getPlayerAll){
         return children.length
       }
      let count=0
      if(this.node.label=="Locations" && this.knownDocs){
        
        for(var d in this.knownDocs){
          if(this.knownDocs[d].indexOf("Loc-")>-1){
            count ++
          }
        }
      }else{
      for(var child in children){
        if(children[child].found){
         
          count ++
        }
      }
      }
      return count
    },
    mousedown(){
      
      this.dsx=this.dx
      this.dsy=this.dy
    },
    mouseup(){
      if(Math.pow(this.dsx-this.dx,2)+Math.pow(this.dsy-this.dy,10)<1){

        this.doClick()
      }
    },
    doClick(){
       this.node.selected=!this.node.selected
    },
    dragging1(params){
      this.dx=params.x
      this.dy=params.y
      if(this.dragging){
       // console.log(this._self)
        this.dragging(params,this)
      }
    },
  },
  watch:{
    mode(val){
      alert("mode "+val)
      if(val=="hidden"){
        this.visible=false
      }else{
        this.visible=true
      }
    }
  }
};
</script>

<style lang="scss" scoped>
 @import "@/assets/sass/variables.scss";
//$border-blue:#00bbff;
.connectedElement{
    position: absolute;
    top: 0px;
    left: 0px;
    z-index:1;
    pointer-events: auto;
}

</style>
